import SecureLS from 'secure-ls'
import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
import PermissionError from '../components/GeneralViews/PermissionError.vue'
// Dashboard pages
// const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue')
const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview2.vue')
const Maintenance = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Maintenance.vue')
const Widgets = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Widgets.vue')
const PendingEvaluations = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/PendingEvaluations.vue')
const FinishedEvaluations = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/FinishedEvaluations.vue')
const DeliveredEvaluations = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/DeliveredEvaluations.vue')

// User pages
const Users = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Users/Users.vue')


// Parametrization pages
const ActivityTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/ActivityTypes.vue')
const AnalystTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/AnalystTypes.vue')
const CreditPurposes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/CreditPurposes.vue')
const CreditRequestStages = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/CreditRequestStages.vue')
const CreditTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/CreditTypes.vue')
const IdentificationDocumentTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/IdentificationDocumentTypes.vue')
const Offices = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Offices.vue')
const ProductTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/ProductTypes.vue')
const Regionals = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Regionals.vue')
const Settings = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Settings.vue')
const Permissions = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Permissions.vue')
const AnalystOffice = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/AnalystOffice.vue')


//Asessment pages
const PushAssessment = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/PushAssessment.vue')
const AssesmentMenu = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/AssesmentMenu.vue')
const PersonalData = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/PersonalData.vue')
const FM100 = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/FM100.vue')
const FM102 = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/FM102.vue')
const RequestData = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/RequestData.vue')
const CashFlow = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/CashFlow.vue')
const SalesCostsSelection = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/SalesCostsSelection.vue')
const PymeGeneralCostsSelection = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/PymeGeneralCostsSelection.vue')
const Sales = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Sales/Sales.vue')
// const Costs = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Costs.vue')
const BusinessGeneralCosts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Business/General.vue')
const BusinessGeneralCostsAddProduct = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Business/GeneralAddProduct.vue')
const BusinessGeneralCostsEditProduct = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Business/GeneralEditProduct.vue')
const BusinessPymeGeneralCosts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Business/Pyme/General.vue')
const BusinessPymeGeneralCostsAddProduct = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Business/Pyme/GeneralAddProduct.vue')
const BusinessPymeGeneralCostsEditProduct = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Business/Pyme/GeneralEditProduct.vue')
const BusinessCatalogCosts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Business/Catalog.vue')
const CostsItemGeneralSelect = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/CostsItemGeneralSelect.vue')
const ProductionGeneralCosts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Production/ProductionGeneral.vue')
const ProductionGeneralCostsEditProduct = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Production/ProductionEditDetail.vue')
const ServicesGeneralCosts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Services/General.vue')
const ServicesTransportCosts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Services/Transport.vue')
const ServicesPymeTransportCosts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Services/TransportPyme.vue')
const ProductionItemCosts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Production/ProductionItem.vue')
const ProductionItemCostsAddDetail = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Production/ProductionAddDetail.vue')
const ProductionItemCostsEditDetail = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Production/ProductionEditDetail.vue')
const ProductionPymeItemCosts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Production/Pyme/General.vue')
const ProductionPymeItemCostsAddDetail = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Production/Pyme/GeneralAddProduct.vue')
const ProductionPymeItemCostsEditDetail = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Production/Pyme/GeneralEditProduct.vue')
const OperatingExpenses = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/OperatingExpenses.vue')
const OperatingExpensesOld = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/Old/OperatingExpensesOld.vue')
const BusinessReferences = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/BusinessReferences.vue')
const AdditionalInformation = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/AdditionalInformation.vue')
const AdditionalInformationOld = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/Old/AdditionalInformationOld.vue')
const AdditionalInformationConsumer = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/AdditionalInformationConsumer.vue')
const AdditionalInformationConsolidated = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/AdditionalInformationConsolidated.vue')
const AdditionalInformationConsolidatedOld = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/Old/AdditionalInformationConsolidatedOld.vue')
const CharacterAnalysis = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/CharacterAnalysis.vue')
const CharacterAnalysisChart = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/CharacterAnalysisChart.vue')
const FinancialIndicators = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/FinancialIndicators.vue')
const FinancialIndicatorsOld = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/Old/FinancialIndicatorsOld.vue')
const FinancialIndicatorsConsumer = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/FinancialIndicatorsConsumer.vue')
const SynchronizationAssesment = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/SynchronizationAssesment.vue')
const SynchronizationAssesmentOld = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/Old/SynchronizationAssesmentOld.vue')
const Salary = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/Salary.vue')
const FinancialObligation = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/FinancialObligations.vue')
const WillingnessToPay = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Costs/Others/WillingnessToPay.vue')
// Logs pages
const OnlineUsers = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Logs/OnlineUsers.vue')
const SystemLogging = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Logs/SystemLogging.vue')
const ErrorLogging = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Logs/ErrorLogging.vue')
//Agro pages
const Inventory = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/Inventory.vue')
const Estate = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/Estate.vue')
const Machinery = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/Machinery.vue')
const Product = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/Product.vue')
const AgroSalary = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/Salary.vue')
const Expenses = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/Expenses.vue')
const Labour = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/Labour.vue')
const AnotherExpenses = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/AnotherExpenses.vue')
const AgroFinancialObligation = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/FinancialObligations.vue')
const HistoricalYields = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/HistoricalYields.vue')
const SeasonalSales = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/SeasonalSales.vue')
const AgroCashFlow = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/CashFlow.vue')
const AgroCashFlowStepTwo = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Asessments/Customer/Agro/CashFlowStepTwo.vue')

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import PasswordChange from 'src/components/Dashboard/Views/Pages/Password/PasswordChange.vue'
import PasswordReset from 'src/components/Dashboard/Views/Pages/Password/PasswordReset.vue'
import PasswordResetEnd from 'src/components/Dashboard/Views/Pages/Password/Reset.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
const RegularForms  = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/RegularForms.vue')
const ExtendedForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ExtendedForms.vue');
const ValidationForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ValidationForms.vue')
const Wizard = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/Wizard.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/RegularTables.vue');
const ExtendedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/ExtendedTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/PaginatedTables.vue');
// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/GoogleMaps.vue')
const FullScreenMap = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/FullScreenMap.vue')
const VectorMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue');

// Calendar
import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
import store from '../store/store'
// Charts
const Charts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Charts.vue')
const permissions = new SecureLS({encodingType: 'aes'});
// const permissions_array = permissions.get('permissions').data;
let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let passwordChange = {
  path: '/password_change',
  name: 'PasswordChange',
  component: PasswordChange
}

let passwordReset = {
  path: '/reset_password/:user_id/:token',
  name: 'PasswordReset',
  component: PasswordReset
}

let passwordResetEnd = {
  path: '/reset',
  name: 'PasswordResetEnd',
  component: PasswordResetEnd
}

let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: 'users',
        name: 'Usuarios',
        component: Users,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view office") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/regionals',
        name: 'Regionales',
        component: Regionals,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view regional") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/offices',
        name: 'Oficinas',
        component: Offices,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view office") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/analyst_types',
        name: 'Tipos de Analista',
        component: AnalystTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view analyst type") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/credit_request_stages',
        name: 'Etapas del crédito',
        component: CreditRequestStages,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view credit request stage") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/product_types',
        name: 'Tipos de producto',
        component: ProductTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view product type") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/credit_types',
        name: 'Tipos de crédito',
        component: CreditTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view credit type") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/identification_document_types',
        name: 'Tipos de documento',
        component: IdentificationDocumentTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view identification document type") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/activity_types',
        name: 'Tipos de actividad',
        component: ActivityTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view activity type") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/credit_purposes',
        name: 'Destinos del crédito',
        component: CreditPurposes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view credit purpose") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/settings',
        name: 'Variables del sistema',
        component: Settings,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view system settings") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/permissions',
        name: 'Roles y permisos',
        component: Permissions,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view group") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'logs/online_users',
        name: 'Usuarios conectados',
        component: OnlineUsers,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view session") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'logs/system_logging',
        name: 'Ingresos al sistema',
        component: SystemLogging,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("Can view access attempt") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'push',
        name: 'Push Evaluación',
        component: PushAssessment,
      },
      {
        path: 'asessments/menu',
        name: 'Menú de evaluación',
        component: AssesmentMenu,
        beforeEnter: (to, from, next) => {
          if (!store.state.assesmentEditing) {
            store.state.beforePathMenu = from.path;
          }
          next();
        }
      },
      {
        path: 'asessments/new_asessment/customer/personal_data',
        name: 'Datos personales',
        component: PersonalData,
      },
      {
        path: 'asessments/new_asessment/customer/fm100',
        name: 'FM100',
        component: FM100,
      },
      {
        path: 'asessments/new_asessment/customer/fm102',
        name: 'FM102',
        component: FM102,
      },
      // {
      //   path: 'asessments/new_asessment/customer/fm102',
      //   name: 'FM102',
      //   component: PersonalData,
      // },
      {
        path: 'asessments/new_asessment/customer/request_data',
        name: 'Datos de solicitud',
        component: RequestData,
      },
      {
        path: 'asessments/new_asessment/customer/cash_flow',
        name: 'Flujo de caja',
        component: CashFlow,
      },
      //Agro pages
      {
        path: 'asessments/new_asessment/customer/agro/inventory',
        name: 'Inventario agrícola y pecuario',
        component: Inventory,
      },
      {
        path: 'asessments/new_asessment/customer/agro/estate',
        name: 'Inmuebles',
        component: Estate,
        component: Estate,
      },
      {
        path: 'asessments/new_asessment/customer/agro/machinery',
        name: 'Maquinaria',
        component: Machinery,
      },
      {
        path: 'asessments/new_asessment/customer/agro/product',
        name: 'Productos almacenados',
        component: Product,
      },
      {
        path: 'asessments/new_asessment/customer/agro/salary',
        name: 'Jornales y Salarios',
        component: AgroSalary,
      },
      {
        path: 'asessments/new_asessment/customer/agro/expenses',
        name: 'Egresos',
        component: Expenses,
      },
      {
        path: 'asessments/new_asessment/customer/agro/labour',
        name: 'Mano de obra',
        component: Labour,
      },
      {
        path: 'asessments/new_asessment/customer/agro/another_expenses',
        name: 'Otros gastos',
        component: AnotherExpenses,
      },
      {
        path: 'asessments/new_asessment/customer/agro/historical_yields',
        name: 'Rendimientos históricos',
        component: HistoricalYields,
      },
      {
        path: 'asessments/new_asessment/customer/agro/seasonal_sales',
        name: 'Ingresos por ventas estacionales',
        component: SeasonalSales,
      },
      {
        path: 'asessments/new_asessment/customer/agro/cash_flow',
        name: 'Flujo de caja',
        component: AgroCashFlow,
      },
      {
        path: 'asessments/new_asessment/customer/agro/cash_flow_2step',
        name: 'Flujo de caja',
        component: AgroCashFlowStepTwo,
      },
      {
        path: 'asessments/new_asessment/customer/sales_costs_selection',
        name: 'Selección de costos y ventas',
        component: SalesCostsSelection,
      },
      {
        path: 'asessments/new_asessment/customer/pyme_general_costs_selection',
        name: 'Selección de costos y ventas',
        component: PymeGeneralCostsSelection,
      },
      {
        path: 'asessments/new_asessment/customer/sales',
        name: 'Selección de ventas',
        component: Sales,
      },
      {
        path: 'asessments/new_asessment/customer/costs/business/general',
        name: 'Selección de costos - General',
        component: BusinessGeneralCosts,
      },
      {
        path: 'asessments/new_asessment/customer/costs/business/pyme/general',
        name: 'Selección de costos - General',
        component: BusinessPymeGeneralCosts,
      },
      {
        path: 'asessments/new_asessment/customer/costs/business/catalog',
        name: 'Selección de costos - Catálogo',
        component: BusinessCatalogCosts,
      },
      {
        path: 'asessments/new_asessment/customer/costs/business/general/add_product',
        name: 'Agregar producto',
        component: BusinessGeneralCostsAddProduct,
      },
      {
        path: 'asessments/new_asessment/customer/costs/business/pyme/general/add_product',
        name: 'Agregar producto',
        component: BusinessPymeGeneralCostsAddProduct,
      },
      {
        path: 'asessments/new_asessment/customer/costs/business/general/edit_product',
        name: 'Editar producto',
        component: BusinessGeneralCostsEditProduct,
      },
      {
        path: 'asessments/new_asessment/customer/costs/business/pyme/general/edit_product',
        name: 'Editar producto',
        component: BusinessPymeGeneralCostsEditProduct,
      },
      {
        path: 'asessments/new_asessment/customer/costs_item_general_selection',
        name: 'Selección general ó item',
        component: CostsItemGeneralSelect,
      },
      {
        path: 'asessments/new_asessment/customer/costs/production/general',
        name: 'Producción general',
        component: ProductionGeneralCosts,
      },
      {
        path: 'asessments/new_asessment/customer/costs/production/item',
        name: 'Producción ítem',
        component: ProductionItemCosts,
      },
      {
        path: 'asessments/new_asessment/customer/costs/production/item/add_detail',
        name: 'Producción - Agregar detalle',
        component: ProductionItemCostsAddDetail,
      },
      {
        path: 'asessments/new_asessment/customer/costs/production/item/edit_detail',
        name: 'Producción - Editar detalle',
        component: ProductionItemCostsEditDetail,
      },
      {
        path: 'asessments/new_asessment/customer/costs/production/pyme/item',
        name: 'Producción ítem',
        component: ProductionPymeItemCosts,
      },
      {
        path: 'asessments/new_asessment/customer/costs/production/pyme/item/add_detail',
        name: 'Producción - Agregar detalle',
        component: ProductionPymeItemCostsAddDetail,
      },
      {
        path: 'asessments/new_asessment/customer/costs/production/pyme/item/edit_detail',
        name: 'Producción - Editar detalle',
        component: ProductionPymeItemCostsEditDetail,
      },
      {
        path: 'asessments/new_asessment/customer/costs/services/general',
        name: 'Servicios generales',
        component: ServicesGeneralCosts,
      },
      {
        path: 'asessments/new_asessment/customer/costs/services/transport',
        name: 'Servicios de transporte',
        component: ServicesTransportCosts,
      },
      {
        path: 'asessments/new_asessment/customer/costs/services/pyme-transport',
        name: 'Servicios de transporte',
        component: ServicesPymeTransportCosts,
      },
      {
        path: 'asessments/new_asessment/customer/others/operating_expenses_old',
        name: 'Gastos operativos e inventarios - Versión anterior',
        component: OperatingExpensesOld,
      },
      {
        path: 'asessments/new_asessment/customer/others/operating_expenses',
        name: 'Gastos operativos e inventarios',
        component: OperatingExpenses,
        beforeEnter: (to, from, next) => {
          // Acceder al assessment actual
          const currentAssessment = store.state.assesments[store.state.actualAssesment];

          console.log('Assessment actual:', currentAssessment);

          if (currentAssessment && currentAssessment.customer.studies.length > 0) {
            // Obtener el índice del estudio actual
            const index = 0;

            // Buscar el producto en los getters del store
            const product = store.getters.getProductTypes.find(product =>
              product.id == currentAssessment.customer.studies[index].productType
            );

            console.log('Producto encontrado:', product);

            if (product) {
              const productName = product.name.toLowerCase();
              console.log('Nombre del producto:', productName);

              // Verificar si es microcrédito o consumo
              if (productName === 'microcrédito' || productName === 'consumo') {
                console.log('Es microcrédito o consumo, redirigiendo al old');
                next('/asessments/new_asessment/customer/others/operating_expenses_old');
                return;
              }
            }

            console.log('No es microcrédito ni consumo, continuando normal');
            next(); // Continuar normal
          } else {
            console.log('Redirigiendo al overview por falta de datos');
            next('/admin/overview');
          }
        }
      },
      {
        path: 'asessments/new_asessment/customer/others/business_references',
        name: 'Referencias de negocio',
        component: BusinessReferences,
      },
      {
        path: 'asessments/new_asessment/customer/others/additional_information_old',
        name: 'Información adicional - Versión anterior',
        component: AdditionalInformationOld,
      },
      {
        path: 'asessments/new_asessment/customer/others/additional_information',
        name: 'Información adicional - Microcrédito',
        component: AdditionalInformation,
        beforeEnter: (to, from, next) => {
          // Acceder al assessment actual
          const currentAssessment = store.state.assesments[store.state.actualAssesment];

          console.log('Assessment actual:', currentAssessment);

          if (currentAssessment && currentAssessment.customer.studies.length > 0) {
            // Obtener el índice del estudio actual
            const index = 0;

            // Buscar el producto en los getters del store
            const product = store.getters.getProductTypes.find(product =>
              product.id == currentAssessment.customer.studies[index].productType
            );

            console.log('Producto encontrado:', product);

            if (product) {
              const productName = product.name.toLowerCase();
              console.log('Nombre del producto:', productName);

              // Verificar si es microcrédito o consumo
              if (productName === 'microcrédito' || productName === 'consumo') {
                console.log('Es microcrédito o consumo, redirigiendo al old');
                next('/asessments/new_asessment/customer/others/additional_information_old');
                return;
              }
            }

            console.log('No es microcrédito ni consumo, continuando normal');
            next(); // Continuar normal
          } else {
            console.log('Redirigiendo al overview por falta de datos');
            next('/admin/overview');
          }
        }
      },
      {
        path: 'asessments/new_asessment/customer/others/consumer_additional_information',
        name: 'Información adicional - Consumo',
        component: AdditionalInformationConsumer,
      },
      {
        path: 'asessments/new_asessment/customer/others/additional_information_consolidated_old',
        name: 'Información adicional consolidada - Versión anterior',
        component: AdditionalInformationConsolidatedOld,
      },
      {
        path: 'asessments/new_asessment/customer/others/additional_information_consolidated',
        name: 'Balance consolidado',
        component: AdditionalInformationConsolidated,
        beforeEnter: (to, from, next) => {
          // Acceder al assessment actual
          const currentAssessment = store.state.assesments[store.state.actualAssesment];

          console.log('Assessment actual:', currentAssessment);

          if (currentAssessment && currentAssessment.customer.studies.length > 0) {
            // Obtener el índice del estudio actual
            const index = 0;

            // Buscar el producto en los getters del store
            const product = store.getters.getProductTypes.find(product =>
              product.id == currentAssessment.customer.studies[index].productType
            );

            console.log('Producto encontrado:', product);

            if (product) {
              const productName = product.name.toLowerCase();
              console.log('Nombre del producto:', productName);

              // Verificar si es microcrédito o consumo
              if (productName === 'microcrédito' || productName === 'consumo') {
                console.log('Es microcrédito o consumo, redirigiendo al old');
                next('/asessments/new_asessment/customer/others/additional_information_consolidated_old');
                return;
              }
            }

            console.log('No es microcrédito ni consumo, continuando normal');
            next(); // Continuar normal
          } else {
            console.log('Redirigiendo al overview por falta de datos');
            next('/admin/overview');
          }
        }
      },
      {
        path: 'asessments/new_asessment/customer/others/character_analysis',
        name: 'Análisis de caracter',
        component: CharacterAnalysis,
      },
      {
        path: 'asessments/new_asessment/customer/others/character_analysis_chart',
        name: 'Gráfico - Análisis de caracter',
        component: CharacterAnalysisChart,
      },
      {
        path: 'asessments/new_asessment/customer/others/financial_indicators_old',
        name: 'Indicadores financieros - Versión anterior',
        component: FinancialIndicatorsOld,
      },
      {
        path: 'asessments/new_asessment/customer/others/financial_indicators',
        name: 'Indicadores financieros',
        component: FinancialIndicators,
        // beforeEnter: (to, from, next) => {
        //   // Acceder al assessment actual
        //   const currentAssessment = store.state.assesments[store.state.actualAssesment];

        //   console.log('Assessment actual:', currentAssessment);

        //   if (currentAssessment && currentAssessment.customer.studies.length > 0) {
        //     // Obtener el índice del estudio actual
        //     const index = 0;

        //     // Buscar el producto en los getters del store
        //     const product = store.getters.getProductTypes.find(product =>
        //       product.id == currentAssessment.customer.studies[index].productType
        //     );

        //     console.log('Producto encontrado:', product);

        //     if (product) {
        //       const productName = product.name.toLowerCase();
        //       console.log('Nombre del producto:', productName);

        //       // Verificar si es microcrédito o consumo
        //       if (productName === 'microcrédito' || productName === 'consumo') {
        //         console.log('Es microcrédito o consumo, redirigiendo al old');
        //         next('/asessments/new_asessment/customer/others/financial_indicators_old');
        //         return;
        //       }
        //     }

        //     console.log('No es microcrédito ni consumo, continuando normal');
        //     next(); // Continuar normal
        //   } else {
        //     console.log('Redirigiendo al overview por falta de datos');
        //     next('/admin/overview');
        //   }
        // }
      },
      {
        path: 'asessments/new_asessment/customer/others/financial_indicators_consumer',
        name: 'Indicadores financieros - Consumo',
        component: FinancialIndicatorsConsumer,
      },
      {
        path: 'asessments/new_asessment/customer/others/assesment_sync_old',
        name: 'Sincronización - Versión anterior',
        component: SynchronizationAssesmentOld,
      },
      {
        path: 'asessments/new_asessment/customer/others/assesment_sync',
        name: 'Sincronización',
        component: SynchronizationAssesment,
        beforeEnter: (to, from, next) => {
          // Acceder al assessment actual
          const currentAssessment = store.state.assesments[store.state.syncAssessment];

          console.log('Assessment actual:', currentAssessment);

          if (currentAssessment && currentAssessment.customer.studies.length > 0) {
            // Obtener el índice del estudio actual
            const index = 0;

            // Buscar el producto en los getters del store
            const product = store.getters.getProductTypes.find(product =>
              product.id == currentAssessment.customer.studies[index].productType
            );

            console.log('Producto encontrado:', product);

            if (product) {
              const productName = product.name.toLowerCase();
              console.log('Nombre del producto:', productName);

              // Verificar si es microcrédito o consumo
              if (productName === 'microcrédito' || productName === 'consumo') {
                console.log('Es microcrédito o consumo, redirigiendo al old');
                next('/asessments/new_asessment/customer/others/assesment_sync_old');
                return;
              }
            }

            console.log('No es microcrédito ni consumo, continuando normal');
            next(); // Continuar normal
          } else {
            console.log('Faltan datos');
            next();
          }
        }
      },
      {
        path: 'asessments/new_asessment/customer/others/salary',
        name: 'Salarios',
        component: Salary,
      },
      {
        path: 'asessments/new_asessment/customer/others/financial-obligations',
        name: 'Obligaciones financieras',
        component: FinancialObligation,
      },
      {
        path: 'asessments/new_asessment/customer/agro/financial_obligations',
        name: 'Obligaciones financieras',
        component: AgroFinancialObligation,
      },
      {
        path: 'admin/maintenance',
        name: 'Mantenimiento',
        component: Maintenance,
      },
      {
        path: 'asessments/new_asessment/customer/others/willingness_to_pay',
        name: 'Voluntad de pago',
        component: WillingnessToPay,
      },
    ]
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  loginPage,
  passwordChange,
  passwordReset,
  passwordResetEnd,
  registerPage,
  lockPage,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'pending_evaluations',
        name: 'Evaluaciones pendientes',
        component: PendingEvaluations
      },
      {
        path: 'finished_evaluations',
        name: 'Evaluaciones cerradas',
        component: FinishedEvaluations
      },
      {
        path: 'delivered_evaluations',
        name: 'Evaluaciones entregadas',
        component: DeliveredEvaluations
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      },

    ]
  },
  {path: '/401', name: 'PermissionError',component: PermissionError},
  {path: '*', component: NotFound}
];

export default routes
